import { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import '../styles/userPoints.css';

const UserPoints = forwardRef(({ accessToken, onPointsChange }, ref) => {
    const [points, setPoints] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [pointsChange, setPointsChange] = useState(0);

    const fetchPoints = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${process.env.REACT_APP_BACK4APP_SERVER_PATH}/get-points?accessToken=${accessToken}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) throw new Error("Failed to fetch points");

            const data = await response.json();
            const newPoints = data.points;
            const difference = newPoints - points;

            setPointsChange(difference);
            setPoints(newPoints);
            if (onPointsChange) onPointsChange(newPoints);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useImperativeHandle(ref, () => ({
        refreshPoints: fetchPoints,
    }));

    useEffect(() => {
        if (!accessToken) return;
        fetchPoints();
    }, [accessToken]);

    if (loading) return (
        <div className="balance-container">
            <span className="balance-title">Balance</span>
            <div className="points-container">
                <div className="points-content loading">
                    <svg width="42" height="27" viewBox="0 0 42 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="1" y="1" width="40" height="25" rx="4" stroke="#9FFF9A" strokeWidth="2" />
                        <circle cx="20.5" cy="13.5" r="5.5" fill="#9FFF9A" />
                    </svg>
                    <p class="loading-points"><span>###</span></p>
                </div>
            </div>
        </div>
    );

    if (error) return <div>Error: {error}</div>;

    return (
        <div className="balance-container">
            <span className="balance-title">Balance</span>
            <div className="points-container">
                <div className="points-content">
                    <svg width="42" height="27" viewBox="0 0 42 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="1" y="1" width="40" height="25" rx="4" stroke="#9FFF9A" strokeWidth="2" />
                        <circle cx="20.5" cy="13.5" r="5.5" fill="#9FFF9A" />
                    </svg>
                    <p className={pointsChange !== 0 ? 'points-animate' : ''}>
                        {points}
                        {pointsChange !== 0 && (
                            <span className={`points-difference ${pointsChange > 0 ? 'positive' : 'negative'}`}>
                                {pointsChange > 0 ? `+${pointsChange}` : pointsChange}
                            </span>
                        )}
                    </p>
                </div>
            </div>
        </div>
    );
});

export default UserPoints;